// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UsersControl.css */
:root {
  --primary-color: #007bff;
  --secondary-bg: #f7f7f7;
  --panel-bg: #fff;
  --border-color: #ddd;
  --text-color: #333;
  --success-color: #28a745;
  --danger-color: #dc3545;
  --hover-bg: #f0f0f0;
}

.users-control-container {
  display: flex;
  flex-direction: column;
  height: 100%; /* Занимает всё пространство родителя */
  padding: 20px;
  background-color: var(--secondary-bg);
  color: var(--text-color);
  box-sizing: border-box;
}

.users-control-container h1 {
  margin: 0 0 20px;
  text-align: center;
  font-family: Arial, sans-serif;
}

.users-control-wrapper {
  display: flex;
  flex: 1 1;
  gap: 20px;
  height: calc(100% - 40px); /* учёт отступов и заголовка */
}

.users-control-sidebar,
.users-control-role {
  width: 250px;
  background-color: var(--panel-bg);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  box-sizing: border-box;
  flex-shrink: 0;
  overflow-y: auto;
}

.users-control-sidebar h2,
.users-control-role h2 {
  margin-top: 0;
  font-size: 20px;
  color: var(--primary-color);
}

.users-control-list {
  list-style: none;
  padding: 0;
  margin: 10px 0;
}

.users-control-item {
  padding: 8px 10px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
  transition: background-color 0.3s;
}

.users-control-item:hover {
  background-color: var(--hover-bg);
}

.users-control-item.active {
  background-color: var(--primary-color);
  color: #fff;
}

.users-control-profile {
  flex: 1 1;
  background-color: var(--panel-bg);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  box-sizing: border-box;
  overflow-y: auto;
}

.users-control-profile h2 {
  margin-top: 0;
  color: var(--primary-color);
}

.users-control-profile-form .users-control-group,
.users-control-role .users-control-group {
  margin-bottom: 10px;
}

.users-control-profile-form label,
.users-control-role label {
  display: block;
  margin-bottom: 5px;
}

.users-control-profile-form input,
.users-control-role input[type="password"],
.users-control-role select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 8px;
}

.users-control-create-btn,
.users-control-profile-form button,
.users-control-role button {
  display: block;
  width: 100%;
  background-color: var(--success-color);
  color: #fff;
  border: none;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
  box-sizing: border-box;
}

.users-control-create-btn:hover,
.users-control-profile-form button:hover,
.users-control-role button:hover {
  background-color: #218838; /* чуть темнее */
}

.users-control-delete-btn {
  background-color: var(--danger-color);
  margin-top: 10px;
}

.users-control-delete-btn:hover {
  background-color: #c82333;
}

/* Модальные стили */
.users-control .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.users-control .modal-container {
  background-color: var(--panel-bg);
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  box-sizing: border-box;
}

.users-control .modal-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.users-control .modal-buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.users-control .modal-btn {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
}

.users-control .modal-save-btn {
  background-color: var(--success-color);
  color: #fff;
}

.users-control .modal-cancel-btn {
  background-color: var(--danger-color);
  color: #fff;
}

.users-control .modal-error {
  color: var(--danger-color);
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/AdminPanel/Pages/UserList.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,uCAAuC;EACrD,aAAa;EACb,qCAAqC;EACrC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,SAAS;EACT,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;;EAEE,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* UsersControl.css */\r\n:root {\r\n  --primary-color: #007bff;\r\n  --secondary-bg: #f7f7f7;\r\n  --panel-bg: #fff;\r\n  --border-color: #ddd;\r\n  --text-color: #333;\r\n  --success-color: #28a745;\r\n  --danger-color: #dc3545;\r\n  --hover-bg: #f0f0f0;\r\n}\r\n\r\n.users-control-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%; /* Занимает всё пространство родителя */\r\n  padding: 20px;\r\n  background-color: var(--secondary-bg);\r\n  color: var(--text-color);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.users-control-container h1 {\r\n  margin: 0 0 20px;\r\n  text-align: center;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.users-control-wrapper {\r\n  display: flex;\r\n  flex: 1;\r\n  gap: 20px;\r\n  height: calc(100% - 40px); /* учёт отступов и заголовка */\r\n}\r\n\r\n.users-control-sidebar,\r\n.users-control-role {\r\n  width: 250px;\r\n  background-color: var(--panel-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  padding: 15px;\r\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\r\n  box-sizing: border-box;\r\n  flex-shrink: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.users-control-sidebar h2,\r\n.users-control-role h2 {\r\n  margin-top: 0;\r\n  font-size: 20px;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.users-control-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 10px 0;\r\n}\r\n\r\n.users-control-item {\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  border-bottom: 1px solid var(--border-color);\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.users-control-item:hover {\r\n  background-color: var(--hover-bg);\r\n}\r\n\r\n.users-control-item.active {\r\n  background-color: var(--primary-color);\r\n  color: #fff;\r\n}\r\n\r\n.users-control-profile {\r\n  flex: 1;\r\n  background-color: var(--panel-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  padding: 15px;\r\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\r\n  box-sizing: border-box;\r\n  overflow-y: auto;\r\n}\r\n\r\n.users-control-profile h2 {\r\n  margin-top: 0;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.users-control-profile-form .users-control-group,\r\n.users-control-role .users-control-group {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.users-control-profile-form label,\r\n.users-control-role label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.users-control-profile-form input,\r\n.users-control-role input[type=\"password\"],\r\n.users-control-role select {\r\n  width: 100%;\r\n  padding: 6px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.users-control-create-btn,\r\n.users-control-profile-form button,\r\n.users-control-role button {\r\n  display: block;\r\n  width: 100%;\r\n  background-color: var(--success-color);\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  transition: background-color 0.3s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.users-control-create-btn:hover,\r\n.users-control-profile-form button:hover,\r\n.users-control-role button:hover {\r\n  background-color: #218838; /* чуть темнее */\r\n}\r\n\r\n.users-control-delete-btn {\r\n  background-color: var(--danger-color);\r\n  margin-top: 10px;\r\n}\r\n\r\n.users-control-delete-btn:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n/* Модальные стили */\r\n.users-control .modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.users-control .modal-container {\r\n  background-color: var(--panel-bg);\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  max-width: 500px;\r\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.users-control .modal-input {\r\n  width: 100%;\r\n  padding: 8px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.users-control .modal-buttons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.users-control .modal-btn {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.users-control .modal-save-btn {\r\n  background-color: var(--success-color);\r\n  color: #fff;\r\n}\r\n\r\n.users-control .modal-cancel-btn {\r\n  background-color: var(--danger-color);\r\n  color: #fff;\r\n}\r\n\r\n.users-control .modal-error {\r\n  color: var(--danger-color);\r\n  margin-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
